export default __webpack_public_path__ + "static/media/user.afec72d1.svg";